import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import Address from "../searchresults/Address";

class AddressDetail extends Component {
  componentDidMount() {}

  render() {
    const node = this.props.addNode ? this.props.addNode : this.props.node;
    return (
      <Table>
        <Table.Body>
          <Table.Row className={`report-sub-section-header`}>
            <Table.HeaderCell colSpan={4}>Address</Table.HeaderCell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Address:</Table.Cell>
            <Table.Cell colSpan={3}>
              <Address
                addressNode={node}
                {...this.props}
              />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }
}

export default AddressDetail;



// WEBPACK FOOTER //
// ./src/components/reports/AddressDetail.js